import { ListingDescriptionContent } from '@pages/Listing/ui/ListingDescriptionPage/ListingDescriptionContent'
import type { ListingSeoIntroView } from '@shared/lib/seo/listing/buildListingSeoIntroView'

type Props = ListingSeoIntroView

/**
 * @function ListingDescriptionServer
 * @description server-only intro блок — полный текст без client collapse
 */
const ListingDescriptionServer = ({ title, description }: Props) => (
  <ListingDescriptionContent title={title} description={description} />
)

export default ListingDescriptionServer
